import $ from 'jquery';

$.fn.buttonSetState = function (state) {
    const $button = $(this);
    const tag = $button.prop('tagName');

    if (tag === 'button' || tag === 'BUTTON') {
        if (state === 'inProgress') {
            return $button
                .addClass('fn-button-inprogress')
                .attr('disabled', 'disabled');
        } else if (state === 'backDefault') {
            return $button
                .removeClass('fn-button-inprogress')
                .removeAttr('disabled');
        }
    }

    return $button;
};

export default $;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/jquery/button-set-state.js